import { render } from "./CreateTransactionModal.vue?vue&type=template&id=6408be8f"
import script from "./CreateTransactionModal.vue?vue&type=script&lang=js"
export * from "./CreateTransactionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__